import axios from '../axiosConfig';

const bookingEtaService = {
  async getTripEtaData(entityId, tripId) {
    const response = await axios.get(`/api/segment-matrix/${entityId}/trips/${tripId}/segments`);
    return response.data?.data || null;
  },

  async getBatchTripEtaData(entityId, tripIds) {
    if (!tripIds.length) return {};
    const response = await axios.get(
      `/api/segment-matrix/${entityId}/trips/batch/segments`,
      { params: { tripIds: tripIds.join(',') } }
    );
    return response.data?.data || {};
  },
};

export default bookingEtaService;
